// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.require > .el-checkbox[data-v-186bacf2] {\r\n  border: 1px solid rgb(245, 108, 108);\n}\n.el-checkbox[data-v-186bacf2] {\r\n  margin-right: 8px;\r\n  padding: 7px 10px 7px 10px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
